import{formatPrice as e}from"@sureapp/platform-sdk";function t(e,{extended:t=!1}={}){const r=`${e.year} ${e.make} ${e.model}`;return t?`${r} ${e.style}`:r}function r(t=0){return t>=1e5?`$${t/1e3}k`:e(t,{fractionDigits:0})}export{r as usDollar,t as vehicleDescription};
//# sourceMappingURL=filters.js.map
